<style lang="scss" scoped>
  .head-action {
    position: relative;
    width: 100%;
    padding: 158px 16px 0;
    min-height: 468px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      min-width: 100%;
      max-width: 1920px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      //background-image: cdn('images/about/vkplay_bg.svg');
      background-image: cdn('images/about/bg.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: 50% 0;
      opacity: 1;
      z-index: -1;
    }

    @include media(max, lg) {
      min-height: 260px;
      padding: 44px 20px 36px;

      &::before {
        height: 160px;
        min-width: auto;
        background-image: cdn('images/about/bg_mob.png');;
        background-size: 100% 100%;
      }
    }

    .logo {
      text-align: center;
      margin-bottom: 10px;

      .icon {
        height: auto;
        width: 460px;

        @include media(max, lg) {
          height: 70px;
          width: 285px;
        }
      }
    }

    .controls {
      display: flex;
      flex-direction: column;
      margin-top: 40px;
      text-align: center;

      & > span {
        display: inline-block;
        margin-top: 20px;
        font-size: 16px;
        line-height: 19px;
        color: #FFFFFF;
        opacity: 0.5;
      }

      .button.download a {
        padding: 14px 40px;
      }

      @include media(max, lg) {
        text-align: center;
        margin-top: 30px;
        max-width: 100%;
        width: 100%;

        .button {
          font-weight: 600;
          font-size: 17px;
          width: 100%;

          &.download a {
            padding: 14px 25px;
          }
        }
      }
    }

    .title {
      font-weight: 700;
      font-size: 30px;
      line-height: 32px;
      letter-spacing: 0.2px;
      text-transform: uppercase;
      color: #FFFFFF;

      @include media(max, lg) {
        font-size: 16px;
        line-height: 18px;
      }
    }

    .subtitle {
      color: #ABABAE;
      opacity: 0.5;

      @include media(max, lg) {
        display: none!important;
      }
    }

    .subtitle-download {
      text-decoration: underline;

      &:hover {
        cursor: pointer;
      }
    }

    .cloud {
      display: flex;
      margin: 30px auto 0;
      max-width: 400px;

      @include media(max, lg) {
        display: none;
      }

      .hd-icon {
        align-self: flex-start;
        display: inline-block;
        padding: 6px 5px;
        background-color: #1C00C9;
        border-radius: 7px;
        margin-right: 10px;
        font-weight: 500;
      }

      &-text {
        color: #D8D8D8;
        text-align: left;
        line-height: 1.3;

      }
    }
  }
</style>

<template>
  <div class="head-action">
    <div class="logo">
      <icon name="logo-vkplay"/>
    </div>
      <h1 class="title">{{$t('title')}}</h1>
    <div class="controls" v-if="isMobile()">
      <btn
          :href="btnUrl"
          :size="'lg'"
          class="fw-semi-bold"
          variant="secondary"
          :class="'fs-18'"
          block>
          {{$t('buttonMobile')}}
      </btn>
    </div>
    <div class="controls" v-else>
      <btn
          download
          v-on:click="downloadGameCenter"
          :size="appIsSmall ? 'lg' : 'xl'"
          class="fw-semi-bold download"
          variant="secondary"
          :class="{
          'fs-18': appIsSmall,
          'fs-24': appIsLarge
         }"
          block>
        <a :href=gcDownloadUrl onclick="return false;" download="">
          <template>{{$t('button')}}</template>
        </a>
      </btn>
      <span class="subtitle">{{$t('clientAvailable')}}
        <span v-if="!isMac" v-on:click="downloadGameCenterForMacOs" class="subtitle-download">{{'macOS'}}</span>
        <span v-else v-on:click="downloadGameCenterForWindows" class="subtitle-download">{{'Windows'}}</span>
      </span>
      <div class="cloud">
        <div class="hd-icon">
          <span>HD</span>
        </div>
        <div class="cloud-text">
          {{$t('cloud')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buildDownloadUrl } from '@utils/helpers';

export default {
  name: 'HeadAction',
  i18n: {
    messages: {
      ru: {
        title: "ИГРАЙ, СМОТРИ, ПОБЕЖДАЙ",
        clientAvailable: 'Клиент также доступен для',
        button: 'Загрузить Игровой центр',
        buttonMobile: 'Перейти',
        cloud: 'Новейшие игры в максимальном качестве легко запустятся даже на старых ноутбуках благодаря технологии CloudGaming',
      },
      en: {
        title: "PLAY, WATCH, WIN",
        clientAvailable: 'Client is also available for',
        button: 'Download GameCenter',
        buttonMobile: 'Visit',
        cloud: 'Cutting-edge games launch easily in the highest quality even on older laptops thanks to CloudGaming technology',
      },
      de: {
        title: "SPIELEN, SCHAUEN, GEWINNEN",
        clientAvailable: 'Der Client ist auch verfügbar für',
        button: 'GameCenter herunterladen',
        buttonMobile: 'Besuchen',
        cloud: 'Dank CloudGaming-Technologie lassen sich die neuesten Spiele – sogar auf älteren Laptops – kinderleicht in höchster Qualität starten.',

      },
      fr: {
        title: "JOUEZ, VISIONNEZ, GAGNEZ",
        clientAvailable: 'Le client est également disponible sur',
        button: 'Télécharger le GameCenter',
        buttonMobile: 'Visiter',
        cloud: 'Des jeux ultramodernes sont facilement jouables en haute définition sur les plus vieux laptops grâce à la technologie du CloudGaming',
      },
      es: {
        title: "JUEGA, MIRA, GANA",
        clientAvailable: 'El cliente también está disponible en',
        button: 'Descargar el GameCenter',
        buttonMobile: 'Visitar',
        cloud: 'Gracias a la tecnología de CloudGaming, los juegos más modernos se abren con la máxima calidad incluso en los portátiles antiguos',
      },
      tr: {
        title: "OYNA, İZLE, KAZAN",
        clientAvailable: 'İstemci için de mevcuttur',
        button: 'GameCenter\'ı indir',
        buttonMobile: 'Ziyaret et',
        cloud: 'CloudGaming teknolojisi sayesinde en yeni oyunlar, eski dizüstü bilgisayarlarda bile en yüksek kalitede kolayca açılır',
      },
      pl: {
        title: "GRAJ, OGLĄDAJ, WYGRYWAJ",
        clientAvailable: 'Klient jest również dostępny na system',
        button: 'Pobierz Centrum gier',
        buttonMobile: 'Odwiedź',
        cloud: 'Dzięki technologii CloudGaming najnowsze gry uruchamiają się z łatwością przy najwyższych ustawieniach graficznych nawet na starszych laptopach',
      },
      ar: {
        title: "العب، شاهد، اربح",
        clientAvailable: 'عميل الألعاب متوفر أيضًا على',
        button: 'تنزيل مركز الألعاب',
        buttonMobile: 'زيارة',
        cloud: 'تعمل الألعاب المتطورة بسهولة بأعلى جودة حتى على أجهزة الكمبيوتر المحمولة القديمة، بفضل تقنية CloudGaming',
      },
    },
  },
  methods: {
    downloadGameCenter() {
      const url = buildDownloadUrl();
      // eslint-disable-next-line
      return window.EVA.gc.detectAndDownload('', url)
    },
    downloadGameCenterForMacOs() {
      const domain = 'https://static.gc.vkplay.ru';
      const url = `${domain}/gcmac/distrib/GameCenterShowcase.dmg`;

      // eslint-disable-next-line
      return window.EVA.gc.detectAndDownload('', url)
    },
    downloadGameCenterForWindows() {
      const domain = 'https://static.gc.vkplay.ru';
      const url = `${domain}/VKPlayLoader.exe`;

      // eslint-disable-next-line
      return window.EVA.gc.detectAndDownload('', url)
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
  },
  computed: {

    btnUrl() {
      return '//vkplay.ru/';
    },
    gcDownloadUrl() {
      if (navigator.appVersion.indexOf('Mac') !== -1) {
        const domain = 'https://static.gc.vkplay.ru';
        return `${domain}/gcmac/distrib/GameCenterShowcase.dmg`;
      }
      return `https://static.gc.vkplay.ru/VKPlayLoader.exe`;
    },
  },
};

</script>
